import { useQuery } from "@tanstack/react-query";
import {
  GET_APP_INIT_DETAILS_MESSAGE_TYPE,
  getAppInitDetails,
} from "api/get-app-init-details";

export const useAppInitDetails = () =>
  useQuery({
    queryKey: [GET_APP_INIT_DETAILS_MESSAGE_TYPE],
    queryFn: getAppInitDetails,
    staleTime: 60_000,
  });
